import RoutesMap from "../../route_control/RouteControl"
import {
    ModuleList,
    UserRoleList,
    ActionList,
    AddAction,
    UpdateAction,
    Permission
} from "../../pages/settings"

export const SettingsImport = {
    RoutesMap,
    ModuleList,
    UserRoleList,
    ActionList,
    AddAction,
    UpdateAction,
    Permission,
}